var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.5C0 7.83502 7.83502 0 17.5 0C27.165 0 35 7.83502 35 17.5C35 27.165 27.165 35 17.5 35C7.83502 35 0 27.165 0 17.5Z",
    fill: "white",
    fillOpacity: 0.17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2051 9.01199C12.1411 9.27751 8.79826 13.2627 9.00946 18.2881C9.10171 20.4877 9.98293 22.3805 10.1917 24.4681C10.2451 25.0089 10.0897 25.6763 10.7112 25.9126C11.4759 26.2025 12.6484 25.7153 13.2893 25.2695C13.5078 25.1209 13.7166 24.948 13.8768 24.7336C14.5396 25.1745 15.1683 25.6008 15.9573 25.7908C19.4312 26.6263 23.2377 24.7141 24.9297 21.6424C28.1099 15.8716 23.8106 8.66609 17.2051 9.01199ZM15.2387 21.0553C14.9644 21.2697 14.6998 21.562 14.3963 21.7301C13.9569 21.9664 13.821 21.7203 13.6559 21.3306C13.1364 20.0907 13.0733 17.9787 13.3767 16.6804C13.7846 14.9143 15.1465 13.3602 17.0181 13.1945C18.9117 13.0264 20.6693 13.9911 21.4631 15.7328C23.2207 19.6084 18.7223 23.4352 15.2387 21.0578V21.0553Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMax);
export default __webpack_public_path__ + "static/media/max.5cad4215223461415a75eb6004564bd6.svg";
export { ForwardRef as ReactComponent };